import Grupo from "../models/grupo";
import { get } from "../utils/ApiUtil";

export const fetchGrupoAsync = async (id: string) => get<Grupo>(`Grupo/${id}`)